export const EStatus = [];

export const ERuleDefaultSettings = [
  {
    label: "General Settings",
    name: "isApplyAllDefaultSettings",
    tooltip: "Apply the system default settings for this supplier.",
  },
  {
    label: "Auto-Create Balancing ESP",
    name: "isBspCost",
    tooltip: 'Select "Yes" if the supplier is settled through the BSP process.',
  },
  // {
  //   label: "Non-Booking-Specific Supplier",
  //   name: "isSharedCost",
  //   tooltip:
  //     'Select "Yes" if the supplier is YGT (e.g., supplier code starts with YGT) or used for general admin, adjustments, or tournament costs not linked to a specific booking.',
  // },
  // {
  //   label: "Supplier Invoice Required",
  //   name: "isInvoiceNeeded",
  //   tooltip: 'Select "Yes" if a supplier invoice or statement is required for matching.',
  // },
  // {
  //   label: "Attempt to Auto-Match",
  //   name: "isAttemptToAutoMatch",
  //   tooltip:
  //     'Select "Yes" to allow the system to automatically match Expected Supplier Payments with Supplier Invoice Records.',
  // },
  {
    label: "Tour Event Supplier",
    name: "isTourEvent",
    tooltip:
      'Select "Yes" if the supplier is YGT (e.g., supplier code starts with YGT) or used for general admin, adjustments, or tournament costs not linked to a specific booking.',
  },
  {
    label: "Other Supplier",
    name: "isOtherSupplier",
    tooltip:
      'Select "Yes" if the supplier is YGT (e.g., supplier code starts with YGT) or used for others not linked to a specific booking.',
  },
  {
    label: "Recalculate All ESPs (Including Exported)",
    name: "isRecalculateEsp",
    tooltip: 'Select "Yes" if a supplier requires an additional deposit or payment following an amendment.',
  },
  {
    label: "Recalculate ESPs on Supplier Terms Changes",
    name: "isRecalculateEspOnTermsChange",
    tooltip:
      'Select "Yes" if the supplier requires the changes in supplier terms to be reflected on existing unexported Expected Supplier Payments.',
  },
  {
    label: "Accept Multiple Invoices from Multiple Suppliers",
    name: "isAcceptMultipleInvoices",
    tooltip:
      'Select "Yes" if Expected Supplier Payments may be invoiced by multiple suppliers and part matching is required. Select acceptable alternative suppliers in the Mappings tab.',
  },
  {
    label: "Match to Linked Supplier",
    name: "isMatchToAlternativeSupplier",
    tooltip:
      'Select "Yes" if invoices may come from alternative suppliers. Select acceptable alternative suppliers in the Mappings tab.',
  },
  {
    label: "Match to Unlinked Finance Supplier",
    name: "isMapToFinanceAccount",
    tooltip:
      'Select "Yes" if alternative suppliers that is not linked will invoice for costs (e.g., a bed bank booking that is invoiced by the hotel).',
  },
  // {
  //   label: "Full Match Source Invoice",
  //   name: "isFullMatchSourceInvoice",
  //   tooltip: 'Select "Yes" if the Supplier Invoice Records must fully match the Expected Supplier Payments.',
  // },
  {
    label: "Add Tax to Invoice",
    name: "isAddTaxToInvoice",
    tooltip:
      'Select "Yes" if the supplier applies tax as a subtotal of the invoice. Select "No" if the supplier applies tax at a booking level.',
  },
  {
    label: "Term Based on Invoice Date",
    name: "isTermBasedOnInvoiceDate",
    tooltip: 'Select "Yes" if the supplier term is based on the invoice date.',
  },
  {
    label: "Auto Match within Tolerance",
    name: "isAutoMatchWithinTolerance",
    tooltip:
      "If this rule is selected, any ESP and SIR matches within acceptable tolerance will be automaticall moved to “Matched” status, bypassing “To Confirm” flag",
  },
  // {
  //   label: "Supersede Final Installment Due Date with Invoice Date",
  //   name: "isSupersedeFinalInstallmentDueDateWithInvoiceDate",
  //   tooltip:
  //     'Select "Yes" if the supplier is to be paid based on the invoice date rather than the due date calculated by the supplier terms.',
  // },
  // {
  //   label: "Create Finance Export Posting Upon Matching",
  //   name: "isCreateFinanceExportPostingUponMatching",
  //   tooltip:
  //     'This controls the timing of the posting. Select "Yes" if the export will be created immediately upon matching. Select "No" if the export will be created inline with the default period before the due date.',
  // },
];

export const ERuleDefaultPaymentTolerances = [
  {
    label: "Payment Tolerances",
    name: "isApplyDefaultTolerance",
    tooltip: "Apply the system default payment tolerances for this supplier.",
  },
  {
    label: "Supplier Payment Tolerance (Percentage)",
    name: "isTolerancePercent",
    tooltip:
      "Enter the acceptable percentage variance between the Expected Supplier Payment and the Supplier Invoice Record.",
    extraInput: "tolerancePercent",
    typeExtraInput: "percentage",
  },

  {
    label: "Supplier Payment Tolerance (Absolute)",
    name: "isToleranceAbsolute",
    tooltip:
      "Enter the acceptable fixed amount variance between the Expected Supplier Payment and the Supplier Invoice Record.",
    extraInput: "toleranceAbsolute",
  },
];

export const ERuleDefaultNominalCodes = [
  {
    label: "Nominal Codes",
    name: "isApplyDefaultSageCodes",
    tooltip: "Apply the system default nominal account codes for this supplier.",
  },
  {
    label: "Nominal Account Debit",
    name: "isSageAccountDebit",
    tooltip: "Select the Nominal code that Debit entries should be posted to",
    selectInput: "sageAccountDebit",
  },
  {
    label: "Nominal Account Credit",
    name: "isSageAccountCredit",
    tooltip: "Select the Nominal code that Credit entries should be posted to",
    selectInput: "sageAccountCredit",
  },
  {
    label: "Unders & Overs Auto-Match Nominal Code",
    name: "isUndersOversAutoMatchCode",
    tooltip: "Select the Nominal code that Unders/Over entries should be posted to",
    selectInput: "undersOversAutoMatchCode",
  },
];

export const ERuleDefaultSettingsDefault = [
  {
    label: "General Settings",
    name: "isApplyAllDefaultSettings",
    tooltip: "Apply the system default settings for this supplier.",
  },
  {
    label: "Auto-Create Balancing ESP",
    name: "isBspCost",
    tooltip: 'Select "Yes" if the supplier is settled through the BSP process.',
  },
  // {
  //   label: "Non-Booking-Specific Supplier",
  //   name: "isSharedCost",
  //   tooltip:
  //     'Select "Yes" if the supplier is YGT (e.g., supplier code starts with YGT) or used for general admin, adjustments, or tournament costs not linked to a specific booking.',
  // },
  {
    label: "Tour Event Supplier",
    name: "isTourEvent",
    tooltip:
      'Select "Yes" if the supplier is YGT (e.g., supplier code starts with YGT) or used for general admin, adjustments, or tournament costs not linked to a specific booking.',
  },
  {
    label: "Other Supplier",
    name: "isOtherSupplier",
    tooltip:
      'Select "Yes" if the supplier is YGT (e.g., supplier code starts with YGT) or used for others not linked to a specific booking.',
  },
  // {
  //   label: "Supplier Invoice Required",
  //   name: "isInvoiceNeeded",
  //   tooltip: 'Select "Yes" if a supplier invoice or statement is required for matching.',
  // },
  // {
  //   label: "Attempt to Auto-Match",
  //   name: "isAttemptToAutoMatch",
  //   tooltip:
  //     'Select "Yes" to allow the system to automatically match Expected Supplier Payments with Supplier Invoice Records.',
  // },
  {
    label: "Recalculate All ESPs (Including Exported)",
    name: "isRecalculateEsp",
    tooltip: 'Select "Yes" if a supplier requires an additional deposit or payment following an amendment.',
  },
  {
    label: "Recalculate ESPs on Supplier Terms Changes",
    name: "isRecalculateEspOnTermsChange",
    tooltip:
      'Select "Yes" if the supplier requires the changes in supplier terms to be reflected on existing unexported Expected Supplier Payments.',
  },
  {
    label: "Accept Multiple Invoices from Multiple Suppliers",
    name: "isAcceptMultipleInvoices",
    tooltip:
      'Select "Yes" if Expected Supplier Payments may be invoiced by multiple suppliers and part matching is required. Select acceptable alternative suppliers in the Mappings tab.',
  },
  {
    label: "Match to Linked Supplier",
    name: "isMatchToAlternativeSupplier",
    tooltip:
      'Select "Yes" if invoices may come from alternative suppliers. Select acceptable alternative suppliers in the Mappings tab.',
  },
  {
    label: "Match to Unlinked Finance Supplier",
    name: "isMapToFinanceAccount",
    tooltip:
      'Select "Yes" if alternative suppliers that is not linked will invoice for costs (e.g., a bed bank booking that is invoiced by the hotel).',
  },
  // {
  //   label: "Full Match Source Invoice",
  //   name: "isFullMatchSourceInvoice",
  //   tooltip: 'Select "Yes" if the Supplier Invoice Records must fully match the Expected Supplier Payments.',
  // },
  {
    label: "Add Tax to Invoice",
    name: "isAddTaxToInvoice",
    tooltip:
      'Select "Yes" if the supplier applies tax as a subtotal of the invoice. Select "No" if the supplier applies tax at a booking level.',
  },
  {
    label: "Term Based on Invoice Date",
    name: "isTermBasedOnInvoiceDate",
    tooltip: 'Select "Yes" if the supplier term is based on the invoice date.',
  },
  {
    label: "Auto Match within Tolerance",
    name: "isAutoMatchWithinTolerance",
    tooltip:
      "If this rule is selected, any ESP and SIR matches within acceptable tolerance will be automaticall moved to “Matched” status, bypassing “To Confirm” flag",
  },
  // {
  //   label: "Supersede Final Installment Due Date with Invoice Date",
  //   name: "isSupersedeFinalInstallmentDueDateWithInvoiceDate",
  //   tooltip:
  //     'Select "Yes" if the supplier is to be paid based on the invoice date rather than the due date calculated by the supplier terms.',
  // },
  // {
  //   label: "Create Finance Export Posting Upon Matching",
  //   name: "isCreateFinanceExportPostingUponMatching",
  //   tooltip:
  //     'This controls the timing of the posting. Select "Yes" if the export will be created immediately upon matching. Select "No" if the export will be created inline with the default period before the due date.',
  // },
];

export const ERuleDefaultPaymentTolerancesDefault = [
  {
    label: "Payment Tolerances",
    name: "isApplyDefaultTolerance",
    tooltip: "Apply the system default payment tolerances for this supplier.",
  },
  {
    label: "Supplier Payment Tolerance (Percentage)",
    name: "isTolerancePercent",
    tooltip:
      "Enter the acceptable percentage variance between the Expected Supplier Payment and the Supplier Invoice Record.",
    //extraInput: "tolerancePercent",
    // typeExtraInput: "percentage",
  },

  {
    label: "Supplier Payment Tolerance (Absolute)",
    name: "isToleranceAbsolute",
    tooltip:
      "Enter the acceptable fixed amount variance between the Expected Supplier Payment and the Supplier Invoice Record.",
    //extraInput: "toleranceAbsolute",
  },
];

export const ERuleDefaultNominalCodesDefault = [
  {
    label: "Nominal Codes",
    name: "isApplyDefaultSageCodes",
    tooltip: "Apply the system default nominal account codes for this supplier.",
  },
  {
    label: "Nominal Account Debit",
    name: "isSageAccountDebit",
    tooltip: "Select the Nominal code that Debit entries should be posted to",
    selectInput: "sageAccountDebit",
  },
  {
    label: "Nominal Account Credit",
    name: "isSageAccountCredit",
    tooltip: "Select the Nominal code that Credit entries should be posted to",
    selectInput: "sageAccountCredit",
  },
  {
    label: "Unders & Overs Auto-Match Nominal Code",
    name: "isUndersOversAutoMatchCode",
    tooltip: "Select the Nominal code that Unders/Over entries should be posted to",
    selectInput: "undersOversAutoMatchCode",
  },
];

export enum InvoiceStatusEnum {
  Query = "Query",
  Duplicated = "Duplicated",
  Accepted = "Accepted",
  Amended = "Amended",
  Rejected = "Rejected",
  Matched = "Matched",
  Exported = "Exported",
}

export enum SupplierInvoiceRecordStatusEnum {
  UNMATCHED = "Unmatched",
  REJECTED = "Rejected",
  PENDING = "Pending",
  MATCHED = "Matched",
  EXPORTED = "Exported",
}

export enum EspStatusEnum {
  UNMATCHED = "Unmatched",
  REJECTED = "Rejected",
  PENDING = "Pending",
  MATCHED = "Matched",
  EXPORTED = "Exported",
}

export enum UserRoleRecordStatusEnum {
  AP_ESCALATION = "apEscalation",
  AP_OWNER = "apOwner",
  PRODUCT_HEAD = "productHead",
  PRODUCT_OWNER = "productOwner",
}

export enum MatchedFlagEnum {
  TOL = "TOL",
  BRF = "BRF",
  SUP = "SUP",
  CST = "CST",
  ESP = "ESP",
  SIR = "SIR",
  GRP = "GRP",
  OTH = "OTH",
  DUP = "DUP",
  REJ = "REJ",
  UNM = "UNM",
}

export enum MatchedTeamEnum {
  PRO = "PRO",
  RES = "RES",
  OCS = "OCS",
  FIN = "FIN",
  LDG = "LDG",
  FLI = "FLI",
}

export enum WorkflowTypeEnum {
  TourEvent = "TourEvent",
  Other = "OtherSupplier",
}

export enum ConfirmTypeEnum {
  CreateBatch = "CreateBatch",
  ChangeStatus = "ChangeStatus",
}

export const ERROR_CODES = {
  SIR_FULL_ERROR: "SIR_FULL_ERROR",
  ESP_FULL_ERROR: "ESP_FULL_ERROR",
};

export enum InvoiceType {
  Flight = "Flight",
  Common = "Common",
}

export enum NOMINAL_CODE_TYPES {
  DEBIT = "PAYMENT_TERM_RULE_NOMINAL_ACCOUNT_DEBIT",
  CREDIT = "PAYMENT_TERM_RULE_NOMINAL_ACCOUNT_CREDIT",
  UNDER_OVERS = "PAYMENT_TERM_RULE_UNDERS_OVERS_AUTO_MATCH",
}

export enum ESPType {
  COMMON = "Common",
  FLIGHT = "Flight",
  TOUR_EVENT = "TourEvent",
  OTHER_SUPPLIER = "OtherSupplier",
}
